module.exports = __webpack_public_path__ + "15201d9119f30f5b1f92b61d86e34726.png";